import { useModal } from 'providers/ModalProvider';

const ModalRoot = () => {
  const { component: Component, hideModal, props } = useModal();

  return Component ? <Component onClose={hideModal} {...props} /> : null;
};

export default ModalRoot;
